import vertexShader from "../../shaders/vertex.vert";
import fragmentShader from "../../shaders/road.frag";
import MAD from "../mad-engine";

export default class Road extends MAD.Entity{
    constructor(){
        super();
        this.size = new THREE.Vector2(7,250);
        this.geometry = new THREE.PlaneGeometry( this.size.x, this.size.y, 1, this.size.y);

        const uniforms = {
            u_size: { type: "vec2", value: this.size },
            u_progress: { type: "float", value: 0 },
            u_curve: { type: "float", value: 0 }
        };
        this.material =  new THREE.ShaderMaterial( {
            vertexShader,
            fragmentShader,
            uniforms,
            side: THREE.DoubleSide
        } );
        this.mesh = new THREE.Mesh( this.geometry, this.material );

        this.mesh.rotation.set(-Math.PI/2,0,0);
        this.mesh.position.set(0,-0.5, -this.size.y / 2);
        this.root.add( this.mesh );

        this.geometryData = {};

        const vertices = this.geometry.attributes.position.array;
        for(let i = 0;i<vertices.length; i += 3){
            const v = new THREE.Vector3(vertices[i], vertices[i + 1], vertices[i + 2]);
            this.geometryData[i] = { 
                position: v,
            }
        }
    }

    update(){
        const { clock } = MAD.App.instance;
        const { noise } = MAD.STORE.data;

        const vertices = this.geometry.attributes.position.array;
        for(let i = 0;i<vertices.length; i += 3){
            const z = this.geometryData[i].position.z + noise.read(this.mesh.position.z - this.geometryData[i].position.y);
            vertices[i + 2] = z;
        }
        this.geometry.attributes.position.needsUpdate = true;
        
        this.material.uniforms.u_progress.value = noise.getProgress();
        this.material.uniforms.u_curve.value = noise.getCurve();
        this.material.uniforms.needsUpdate = true;
    }
}